module.exports = __webpack_public_path__ + "img/Icon-Entities-Active.96ed9c39.svg";